import React, { useState } from 'react'
import { useRouteMatch, useHistory } from 'react-router-dom'

import { Breadcrumb } from 'react-breadcrumbs'
import withStyles from '@material-ui/core/styles/withStyles'
import SettingsIcon from 'Assets/Images/icons/settings'
import { PATHS } from 'Config/Routing/paths'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import TagsManagementForm from '../TagsManagementForm'
import { TAGS_MANAGEMENT_FORM_MODES } from '../const'
import { createTag } from './gql'
import { styles } from './styles'

const BreadcrumbsCreateTag = ({ currentPath }) => {
  return (
    <div>
      <Breadcrumbs icon={<SettingsIcon style={{ width: 20 }} />} />
      <Breadcrumb
        data={{
          title: 'Settings',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
        }}
      />
      <Breadcrumb
        data={{
          title: 'Tags Management',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.tagsManagement
          }`,
        }}
      />
      <Breadcrumb data={{ title: 'Create', pathname: currentPath }} />
    </div>
  )
}

const TagsManagementCreate = ({ classes }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  const navigateBack = () => {
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
        PATHS.settings.tagsManagement
      }`,
    )
  }

  const handleCrateSubmit = async (form, isValid) => {
    if (isValid) {
      setLoading(true)
      const { name, type } = form
      try {
        await createTag({
          value: name.value,
          type: type.value,
        })
        navigateBack()
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <div className={classes.wrapper}>
      <BreadcrumbsCreateTag currentPath={match.url} />
      <TagsManagementForm
        mode={TAGS_MANAGEMENT_FORM_MODES.CREATE}
        handleCancel={navigateBack}
        buttonsDisabled={loading}
        handleSubmit={handleCrateSubmit}
      />
    </div>
  )
}

export default withStyles(styles)(TagsManagementCreate)



// WEBPACK FOOTER //
// ./src/Containers/Settings/TagsManagement/TagsManagementCreate/index.js